import { component } from 'picoapp'
import Splide from '@splidejs/splide'
import { Grid } from '@splidejs/splide-extension-grid'

const DESKTOP_COLUMNS = 4
const MOBILE_COLUMNS = 2

export default component(async (node) => {
  const state = {
    active: null,
  }

  const sliderElement = node.querySelector('.splide')
  const sliderControls = sliderElement.querySelector('[data-slider-controls]')
  const sliderElements = sliderElement.querySelectorAll('.splide__slide')
  const sliderElementsLength = [...sliderElements].length

  let desktopRows = 3
  let mobileRows = 3

  const minimumDesktopRows = Math.ceil(sliderElementsLength / DESKTOP_COLUMNS)
  const minimumMobileRows = Math.ceil(sliderElementsLength / MOBILE_COLUMNS)

  desktopRows = minimumDesktopRows > desktopRows ? desktopRows : minimumDesktopRows
  mobileRows = minimumMobileRows > mobileRows ? mobileRows : minimumMobileRows

  const slider = new Splide(sliderElement, {
    arrows: true,
    mediaQuery: 'min',
    pagination: true,
    perPage: 1,
    grid: {
      dimensions: [[mobileRows, MOBILE_COLUMNS]],
      gap: {
        row: '.75rem',
        col: '.75rem',
      },
    },
    breakpoints: {
      768: {
        grid: {
          dimensions: [[desktopRows, DESKTOP_COLUMNS]],
          gap: {
            row: '1.75rem',
            col: '1.75rem',
          },
        },
      },
    },
  })

  const toggleSliderControls = () => {
    const slides = slider.Components.Slides.getLength()
    if (slides < 2) {
      sliderControls.classList.add('tw-hidden')
    } else {
      sliderControls.classList.remove('tw-hidden')
    }
  }

  const toggleModal = (e) => {
    const target = e.currentTarget.querySelector('[data-bio]')
    if (!target) return
    if (target.contains(e.target)) {
      return
    }

    if (state.active && state.active !== e.currentTarget) {
      closeCurrentModal()
    }

    if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
      openModal(e.currentTarget, target)
    } else {
      closeCurrentModal()
    }
  }

  const openModal = (container, target) => {
    const splideSlide = container.closest('.splide__slide[role="tabpanel"]')
    const splideRows = splideSlide.querySelectorAll('.splide__slide__row')
    const isLastRow = splideRows[splideRows.length - 1].contains(container) && splideRows.length > 1

    if (isLastRow) {
      target.style.top = container.offsetTop - container.offsetHeight + 'px'
      container.setAttribute('data-last-row', 'true')
    } else {
      target.style.top = container.offsetTop + container.offsetHeight + 'px'
    }

    container.setAttribute('aria-expanded', !(container.getAttribute('aria-expanded') === 'true'))
    target.style.height = container.offsetHeight + 'px'
    target.style.left = slider.index * slider.Components.Elements.list.offsetWidth + 'px'
    state.active = container
  }

  const closeCurrentModal = () => {
    if (state.active) {
      state.active.setAttribute('aria-expanded', false)
      if (state.active.getAttribute('data-last-row') === 'true') {
        state.active.setAttribute('data-last-row', 'false')
      }
      state.active = null
    }
  }

  slider.on('updated', () => {
    toggleSliderControls(slider)
  })

  slider.on('mounted', () => {
    toggleSliderControls(slider)
    const profiles = node.querySelectorAll('[data-profile]')
    const closeModalButtons = node.querySelectorAll('[data-modal-close]')
    profiles.forEach((profileElement) => {
      profileElement.addEventListener('click', toggleModal)
    })
    closeModalButtons.forEach((buttonElement) => {
      buttonElement.addEventListener('click', closeCurrentModal)
    })
  })

  slider.on('move', () => {
    closeCurrentModal()
  })

  slider.on('resize', () => {
    closeCurrentModal()
  })

  slider.mount({ Grid })
})
